module.exports = __webpack_public_path__ + "img/slider_19.82f08a08.jpg";